import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { formatComment } from '@src/public/utils/format';
import styles from './index.css';

const Content = ({ content }) => {
    const { replyUser, comment, checkStatus } = content;

    return (
        <div className={styles.content}>
            {replyUser ? (
                <>
                    <span>回复</span>
                    <span className={styles.replyUser}>{replyUser}</span>
                </>
            ) : null}
            <span dangerouslySetInnerHTML={{ __html: formatComment(comment) }} />
            {checkStatus !== 1 ? <span style={{ color: '#9e9e9e' }}>内容审核中，审核通过后发布</span> : null}
        </div>
    );
};

Content.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Content);
